/**************************************************
 * Nombre:       Seccion_Contactos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Contactos_Portada from "./Componentes/Contactos_Portada";
import Contactos_Contactanos from "./Componentes/Contactos_Contactanos";
import Contactanos_Mapa from "./Componentes/Contactanos_Mapa";
import {useEffect} from "react";
import {irArriba} from "../../Utilidades/irArriba";


const Seccion_Contactos = () => {

    useEffect(() => {
        irArriba()
    }, [])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 0}}>
                <Contactos_Portada/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 14}}>
                <Contactos_Contactanos/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 16, mb: -8}}>
                <Contactanos_Mapa/>
            </Grid>


        </Grid>
    )

}
export default Seccion_Contactos